export const endpoints = {
  api: {
    notifications: 'notifications',
    users: 'users',
    categories: 'categories',
    subcategories: 'subcategories',
    articles: 'articles',
    profile: 'profile',
  }
};
